import { render, staticRenderFns } from "./custom-fields.vue?vue&type=template&id=e0ce4af0&"
import script from "./custom-fields.vue?vue&type=script&lang=js&"
export * from "./custom-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports